import React, { useEffect, useState } from "react";
 import theme from "../theme/theme1";
  import { motion } from "framer-motion";
import { INSTITUTION_ASSETS } from "../../../../s3-assets/Institution";

const StaffExperienceSection = () => {
  // State to trigger animations
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById("staff-section");
      const position = element.getBoundingClientRect();
      // Trigger animation when element comes into view
      if (position.top <= window.innerHeight * 0.75) {
        setInView(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      id="staff-section"
      className={`relative h-screen md:h-[80vh] lg:h-[60vh] bg-gray-100 overflow-hidden transition-opacity duration-1000 ease-in-out ${
        inView ? "opacity-100" : "opacity-0"
      }`}
      style={{ fontFamily: theme.staffExperienceSection.fontFamily }}
    >
      {/* First Image (background image) */}
      <img
        src={INSTITUTION_ASSETS.SUCCESS_STORIES_IMAGES.IMAGE_1}
        alt="Background"
        className={`absolute inset-0 w-full h-full object-cover transition-transform duration-1000 ${
          inView ? "scale-100" : "scale-110"
        }`}
      />

      {/* Content (title and paragraph text) on the left */}
      <div
        className={`absolute left-8 md:left-16 lg:left-24 top-1/2 transform -translate-y-1/2 text-${theme.staffExperienceSection.textColor} z-10 max-w-xs md:max-w-sm lg:max-w-md transition-transform duration-1000 ${
          inView ? "translate-x-0" : "-translate-x-20"
        }`}
      >
        <h2
          className={`text-3xl md:text-4xl font-extrabold mb-4 text-${theme.staffExperienceSection.headingTextColor} drop-shadow-md transition-all duration-1000 ${
            inView ? "opacity-100" : "opacity-0"
          }`}
          // style={{ color: "white" }}
        >
          Experienced Teachers
        </h2>
        <p
          className={`text-sm md:text-base lg:text-lg leading-relaxed text-justify transition-opacity duration-1000 ${
            inView ? "opacity-100" : "opacity-0"
          }`}
          style={{ color: "white" }}
        >
          Our team of professionals brings years of experience in delivering
          top-notch education and innovative solutions to help students
          achieve their goals. With a focus on excellence, we work tirelessly
          to provide the best learning experiences and ensure that every
          student receives personalized support. Our staff is committed to
          creating a nurturing environment that encourages growth and success.
        </p>
      </div>

      {/* Overlay Image on the right with rounded left side, moved slightly to the left */}
      <img
        src="https://velammalnexus.com/wp-content/uploads/2023/10/experience.png"
        alt="Staff experience"
        className={`absolute right-[8%] top-1/2 transform -translate-y-1/2 w-2/5 max-w-sm md:max-w-md lg:max-w-lg rounded-full shadow-lg transition-transform duration-1000 ${
          inView ? "scale-100" : "scale-110"
        }`}
        style={{
          boxShadow: theme.staffExperienceSection.imageShadow,
        }}
      />

      {/* Bulb Image on the right end as hanging with good VFX and animation */}
      <motion.div
        className="absolute right-0 top-1/7 w-20 h-20 md:w-20 md:h-20 lg:w-24 lg:h-24"
        initial={{ y: -50, opacity: 0 }}
        animate={{
          y: inView ? 0 : -50,
          opacity: inView ? 1 : 0,
          rotate: inView ? [0, -5, 0, 5, 0] : 0,
        }}
        transition={{
          y: { duration: 1, ease: "easeOut" },
          opacity: { duration: 1, ease: "easeOut" },
          rotate: {
            repeat: Infinity,
            duration: 2,
            ease: "easeInOut",
          },
        }}
      >
        <img
        src={INSTITUTION_ASSETS.SUCCESS_STORIES_IMAGES.BULB}
        alt="Bulb"
          className="w-full h-full object-cover"
        />
      </motion.div>
    </div>
  );
};

export default StaffExperienceSection;
